import { Paper, PaperContent } from '@e3dc-react/shell/Elements/Paper'
import React from 'react'
import { DeviceLinkModel, SystemlogModel } from 'src/Libs/installations/models'
import { SYSTEM_PROTOCOL_LOGS_ID } from 'src/Libs/qa/ids'
import SystemProtocolList from './SystemProtocolList'

interface SystemProtocolLogsProps {
  title: string
  deviceLinks: DeviceLinkModel[]
  isLoadingSystemLogs: boolean
  systemlog: SystemlogModel[]
  showLoadMore: boolean
  loadMore: () => void
  onResolveSystemLog: (installationId: number, logId: number) => void
}

/**
 * Paper card containing the list of system protocol entries
 */
const SystemProtocolLogs: React.FC<SystemProtocolLogsProps> = ({
  title,
  deviceLinks,
  isLoadingSystemLogs,
  systemlog,
  showLoadMore,
  loadMore,
  onResolveSystemLog,
}) => (
  <Paper title={title} dataQa={SYSTEM_PROTOCOL_LOGS_ID}>
    <PaperContent sxStyle={{ mt: 2 }}>
      <SystemProtocolList
        deviceLinks={deviceLinks}
        isLoadingSystemLogs={isLoadingSystemLogs}
        loadMore={loadMore}
        onResolveSystemLog={onResolveSystemLog}
        showLoadMore={showLoadMore}
        systemlog={systemlog}
      />
    </PaperContent>
  </Paper>
)

export default SystemProtocolLogs
